import {
  AddContainer,
  AddInfo,
  AddContacts,
  ShortAddContainer,
  ShortAddWrapper,
} from "./short-add2.styles"
import Button from "../button/button.component"
import { Link } from "react-scroll"

import "./styles.scss"

const ShortAdd2 = ({ props }) => {
  return (
    <ShortAddWrapper className="short-ads2">
      <ShortAddContainer>
        <AddContainer>
          <AddInfo>
            <h2>{props[1]}</h2>
            <span>{props[2]}</span>
          </AddInfo>
          <AddContacts>
            <Link
              to="contacts"
              spy={true}
              smooth={true}
              offset={0}
              duration={500}
            >
              <Button children={props[3]} />
            </Link>
          </AddContacts>
        </AddContainer>
      </ShortAddContainer>
    </ShortAddWrapper>
  )
}

export default ShortAdd2
